import PropTypes from 'prop-types'
import React from 'react'
import InfoPopup from './InfoPopup'

const ProgramFlagCheckbox = (props) => {
  return (
    <div className='form-group small'>
      <div className='form-check'>
        <input
          className='form-check-input'
          name={props.name}
          id={props.name}
          type='checkbox'
          onChange={props.onChange}
          checked={props.checked} />
        <div className='hstack gap-1'>
          <label
            className='form-check-label'
            htmlFor={props.name}>
            {props.label}
          </label>
          {props.description && (<InfoPopup body={props.description}
            containerRef={props.containerRef} />)}
        </div>
      </div>
    </div>
  )
}

ProgramFlagCheckbox.propTypes = {
  onChange: PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  description: PropTypes.string,
  containerRef: PropTypes.object
}

export default ProgramFlagCheckbox
